<template>
  <div class="px-5 py-2">
    <div class="text-xs font-normal leading-6 uppercase">{{ item.name }}</div>
    <div class="text-sm font-medium leading-6">
      {{ item.address }}
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Facility } from '@/models/facility';

@Component
export default class FacilityItem extends Vue {
  @Prop({ type: Object, required: true }) item!: Facility;
}
</script>
